import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { CORE_QUERY_KEYS as INVENTORY_QUERY_KEYS } from 'app/hooks/data/core/extranet/inventory';
import type {
  CalendarPeriod,
  CalendarSlotSeries,
  CreateSeriesPayload,
} from 'app/typings/core/extranet/inventory/calendar';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useCreateSeries(
  hotelId?: number,
  calendarId?: number,
  period?: CalendarPeriod
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateSeriesPayload) =>
      hotelId && calendarId
        ? (apiMutation(
            'POST',
            {
              path: ENDPOINTS.createSeries,
              params: {
                hotelId: hotelId.toString(),
                calendarId: calendarId.toString(),
              },
              queryParams: {
                startDate: period?.startDate,
                endDate: period?.endDate,
              },
            },
            payload
          ) as Promise<CalendarSlotSeries>)
        : Promise.reject(null),
    onSuccess: () => {
      message.success('Recurring availability successfully created');

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.calendar, { hotelId, calendarId }],
      });

      queryClient.invalidateQueries({
        queryKey: [INVENTORY_QUERY_KEYS.inventory, { hotelId }],
      });
    },
    onError: () => {
      message.error('Failed to create recurring availability.');
    },
  });
}
